import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IFilterData, IFilterModel } from '../../models/filter-model';
import { IFilter } from '../../interfaces/ifilter';
import { DatePipe } from '@angular/common';
import { FilterService, IFilterSubject } from '../../services/filter.service';
import { filter } from 'rxjs';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'split-filter-month',
  templateUrl: './split-filter-month.component.html',
  styleUrls: ['./split-filter-month.component.scss']
})
export class SplitFilterMonthComponent {
  @Input() data: IFilterData[] = [];

  @Input() field!: string;

  @Input() label!: string;

  @Input() key!: string;

  @Input() groupId!: string;

  @Input() required: boolean = false;
  
  @Input() view: 'year' | 'month' = 'month';

  protected _data: any;

  protected filterModel!: IFilterModel;

  @Input() set initialValue(data : any) {
    this._data = data;
  }

  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();

  @ViewChild('op') public overlayPanel!: OverlayPanel;
  isActiveOverlay: boolean = false;

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    //this.filterService.filters = this.filterModel;

    this.filterService.filterSubject.pipe(
      filter((data: IFilterSubject) => data.action === "CLEAR"),
      filter((event: IFilterSubject) => event.id === this.groupId),
      filter((event: IFilterSubject) =>  this.required == false)
    ).subscribe(
      (data: IFilterSubject) => {
        this._data = undefined;
        this.onEmit();
      }
    )
  }

  ngOnChanges(changes: SimpleChanges): void {
   if(changes["data"]) {
     this._data = this.copy();
   }  

   if(changes["key"]) {
    this.filterModel = {
      id: this.groupId,
      type: "MONTH",
      key: this.key,
      data: this._data,
      component: this,
      filter: []
    }

    let filterModel = this.generateFilter();
    this.filterService.filters = filterModel;
    //this.onEmit();
   }
  }

  copy() {
    let {name} = this.data[0];
    return name ? new Date(name.getFullYear(), name.getMonth(), 1) : undefined;
  }

  showOverlayPanel(event: any) {
    this.overlayPanel.show(event);
    this.isActiveOverlay = true;
  }

  hideOverlayPanel() {
    this._data = this.copy();
    this.isActiveOverlay = false;
  }

  onCancel() {
    this._data = undefined;
    this.onEmit();
    this.overlayPanel.hide();
  }

  onEmit() { 
    let filterModel = this.generateFilter();
    
    this.data = filterModel.data;
    this.filterService.send(filterModel);
    this.onFilterEvent.emit(filterModel);
    if(this.isActiveOverlay) {
      this.overlayPanel.hide(); 
    }
  }

  generateFilter() {
    let filter: IFilter[] = [];
    let data: IFilterData[] = [];
    if(this._data) {
      data = [{id: this._data, name: this._data}] as IFilterData[];
      let date =  this.tranformDateInString(this._data,this.view);

      if(this.view == 'year') {
        filter = [
          {
            key: this.key,
            property: this.field,
            value: date
          }
        ];
      } else {
        filter = [
          {
            key: this.key,
            fields: ["after"],
            property: this.field,
            value: date
          },
          {
            key: this.key,
            fields: ["before"],
            property: this.field,
            value: date
          }
        ];
      }
    }

    let filterModel: IFilterModel  = {
      ...this.filterModel,
      data: data,
      filter: filter
    };

    return filterModel;
  }



  tranformDateInString(date?: Date, view?: 'year' | 'month') {
    return new DatePipe("pt-BR").transform(date, (view =='year' ? 'yyyy' : 'yyyy-MM-dd')) as string;
  }

  isValidDate(date: Date){
    return date.toString() !== 'Invalid Date';
  }
}
